import { ReactElement, useState, MouseEvent } from "react";
import {
  autoUpdate,
  flip,
  offset,
  Placement,
  shift,
  Strategy,
  useFloating,
} from "@floating-ui/react-dom";

export default function Dropdown({
  trigger,
  children,
  disabled = false,
  placement,
  strategy,
}: {
  trigger:
    | ReactElement
    | (({ expanded }: { expanded: boolean }) => ReactElement);
  children: ReactElement;
  disabled?: boolean;
  placement?: Placement;
  strategy?: Strategy;
}) {
  const [open, setIsOpen] = useState(false);
  const { refs, floatingStyles } = useFloating({
    whileElementsMounted: autoUpdate,
    placement,
    open,
    strategy,
    middleware: [offset(5), flip(), shift()],
  });

  return (
    <div>
      <div
        ref={refs.setReference}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setIsOpen(!disabled);
        }}
        className="cursor-pointer select-none"
      >
        {typeof trigger === "function" ? trigger({ expanded: open }) : trigger}
      </div>
      {open && (
        <>
          <div
            className="fixed w-screen h-screen top-0 left-0 z-10"
            onClick={handleClickOutsideContent}
          ></div>
          <div
            className="shadow-xl z-20 rounded-lg border-slate-300 border bg-white p-1"
            ref={refs.setFloating}
            style={floatingStyles}
            onClick={handleClickContent}
          >
            {children}
          </div>
        </>
      )}
    </div>
  );

  function handleClickOutsideContent(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    if (e.currentTarget === e.target) {
      setIsOpen(false);
    }
  }

  function handleClickContent(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(false);
  }
}
